import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'drfSmgSetting',
  props: {
    value: {
      type: Object,
      return: function _return() {}
    },
    edit: Boolean
  },
  watch: {
    value: {
      handler: function handler(newVal) {
        if (newVal && Number(newVal.drf_smg_rule_type) === 0) {
          this.value.drf_smg_tip_content = this.value.drf_smg_default_tip_content;
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      imgSrc: 'https://res.youlianfuwu.com/voucher/shop/drf_smg_info.jpg',
      imgStyle: {
        width: '220px',
        height: '100px',
        marginTop: '10px'
      },
      list: [{
        name: '默认规则',
        id: 0
      }, {
        name: '个性化',
        id: 1
      }]
    };
  },
  mounted: function mounted() {
    if (this.value.drf_smg_rule_type === 0) {
      this.changeType(0);
    }
  },
  methods: {
    changeType: function changeType(type) {
      if (type === 1) {
        this.value.drf_smg_tip_content = '';
      } else {
        this.value.drf_smg_tip_content = this.value.drf_smg_default_tip_content;
      }
    }
  }
};